import { ResponsiveBar } from '@nivo/bar'

// Custom tooltip component
const CustomTooltip = ({ id, value, indexValue, data }) => (
    <div
        style={{
            background: 'white',
            padding: '9px 12px',
            border: '1px solid #ccc',
            borderRadius: '4px',
            boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
            maxWidth: '280px',
        }}
    >
        <strong style={{ color: '#333', display: 'block', marginBottom: '4px' }}>
            {indexValue}
        </strong>
        {data.kpiName && (
            <span style={{ color: '#666', fontSize: '12px', display: 'block', marginBottom: '6px' }}>
                {data.kpiName}
            </span>
        )}
        <span style={{ color: '#333' }}>
            {id}: <strong>{value.toFixed(2)}%</strong>
        </span>
    </div>
)

const BarChart = ({ data, keys, groupMode, legend, layout }) => (
    <ResponsiveBar
        data={data}
        keys={keys}
        indexBy="country"
        margin={{ top: 20, right: 50, bottom: 20, left: 150 }}
        padding={0.4}
        groupMode={groupMode ? "stacked":"grouped"}
        layout={layout ? layout: "horizontal"}
        maxValue={100}
        valueScale={{ type: 'linear' }}
        indexScale={{ type: 'band', round: true }}
        colors={({ id, data }) => data[`${id}Color`]}
        borderColor={{ from: 'color', modifiers: [ [ 'darker', 1.6 ] ] }}
        axisTop={null}
        axisRight={null}
        colorBy="id"
        labelFormat={v => `${v.toFixed(2)}%`}
        tooltip={CustomTooltip}
        axisBottom={{
            tickSize: 5,
            tickPadding: 5,
            tickRotation: 0,
            legend: '',
            legendPosition: 'middle',
            legendOffset: 32,
            format: v => `${v}%`
        }}
        axisLeft={{
            tickSize: 5,
            tickPadding: 5,
            tickRotation: 0,
            legend: '',
            legendPosition: 'middle',
            legendOffset: -40,
        }}
        enableGridY={true}
        labelSkipWidth={12}
        labelSkipHeight={12}
        labelTextColor={{ from: 'color', modifiers: [ [ 'darker', 2.2 ] ] }}
        legends={legend ?[
            {
                dataFrom: 'keys',
                anchor: 'top-center',
                direction: 'row',
                justify: false,
                translateX: -20,
                translateY: -20,
                itemsSpacing: 2,
                itemWidth: 210,
                itemHeight: 10,
                itemDirection: 'left-to-right',
                itemOpacity: 0.85,
                symbolSize: 20,
                legendFormat: (d)=>{'hello'},
                effects: [
                    {
                        on: 'hover',
                        style: {
                            itemOpacity: 1,
                        }
                    }
                ]
            }
        ]:[]}
        animate={true}
        motionStiffness={90}
        motionDamping={15}
    />
)

export default BarChart